import { css } from 'styled-components';

export const Defaults = css`
    background-color: ${p => p.theme.colors.background};
    color: ${p => p.theme.colors.default};
    a { color: ${p => p.theme.colors.default}; }
`;
